import styled from "styled-components";

export const ManagerButton = styled.button`
  align-items: center;
  background: #eef4ff;
  border: 1px solid #cfe0ff;
  border-radius: 999px;
  color: #2458bd;
  cursor: pointer;
  display: inline-flex;
  font: 13px rebondG-Semi-Bold;
  gap: 7px;
  margin: 10px 0 0 10px;
  padding: 6px 13px;
  transition: all .16s ease;

  &:hover:not(:disabled) {
    background: #dfeaff;
    border-color: #a9c6fb;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: .42;
  }
`;

export const ModalIntro = styled.div`
  color: #64748b;
  font: 13px/1.55 rebondG-Regular;
  margin-bottom: 16px;
`;

export const SearchWrap = styled.label`
  align-items: center;
  background: #f8fafc;
  border: 1px solid #dde5ef;
  border-radius: 12px;
  color: #94a3b8;
  display: flex;
  gap: 9px;
  margin-bottom: 14px;
  padding: 0 13px;

  &:focus-within {
    border-color: #8eb1f5;
    box-shadow: 0 0 0 3px rgba(47, 103, 216, .08);
  }
`;

export const SearchInput = styled.input`
  background: transparent;
  border: 0;
  color: #0f172a;
  flex: 1;
  font: 13px rebondG-Medium;
  height: 42px;
  min-width: 0;
  outline: 0;
`;

export const MemberList = styled.div`
  border: 1px solid #e7edf4;
  border-radius: 14px;
  max-height: 390px;
  overflow-y: auto;
`;

export const MemberRow = styled.div`
  align-items: center;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  transition: background .15s ease;

  &:last-child { border-bottom: 0; }
  &:hover { background: #fafcff; }
`;

export const Avatar = styled.div`
  align-items: center;
  background: linear-gradient(145deg, #3e79e8, #2458bd);
  border-radius: 11px;
  color: #fff;
  display: flex;
  flex: 0 0 40px;
  font: 13px rebondG-Bold;
  height: 40px;
  justify-content: center;
  overflow: hidden;

  img { height: 100%; object-fit: cover; width: 100%; }
`;

export const MemberInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const MemberName = styled.strong`
  color: #172033;
  display: block;
  font: 13px rebondG-Semi-Bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MemberEmail = styled.span`
  color: #8492a6;
  display: block;
  font: 11px rebondG-Regular;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ManagerBadge = styled.span`
  background: #e9f8ef;
  border-radius: 999px;
  color: #15803d;
  font: 10px rebondG-Semi-Bold;
  padding: 5px 8px;
`;

export const ActionButton = styled.button`
  background: ${({ $remove }) => $remove ? "#fff1f2" : "#eef4ff"};
  border: 1px solid ${({ $remove }) => $remove ? "#fecdd3" : "#cfe0ff"};
  border-radius: 9px;
  color: ${({ $remove }) => $remove ? "#be123c" : "#2458bd"};
  cursor: pointer;
  font: 11px rebondG-Semi-Bold;
  min-width: 72px;
  padding: 7px 10px;

  &:disabled { cursor: wait; opacity: .55; }
`;

export const EmptyState = styled.div`
  align-items: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  font: 13px rebondG-Medium;
  gap: 9px;
  justify-content: center;
  min-height: 180px;
  padding: 30px;
  text-align: center;
`;

export const ManagerCount = styled.span`
  background: #eef4ff;
  border-radius: 999px;
  color: #2f67d8;
  font: 11px rebondG-Semi-Bold;
  margin-left: 8px;
  padding: 5px 8px;
`;
